import { BusyButton } from '@ztechapps/webui.button'
import { useFormikContext } from 'formik'
import React from 'react'
import { useCreateAndBuildContext } from './Context'
import type { CreateAndBuildWorkOrderArgs, WorkOrder, WorkOrderItem } from '@ztechapps/common.contract'
import map from 'lodash/map'
import { useError, useToast } from '@ztechapps/common.hook'
import { useCreateWorkOrderWithTasks } from '@ztechapps/work-order.common'

export const DelayedProductionButton = () => {
  const { values } = useFormikContext<CreateAndBuildWorkOrderArgs>()
  const { relatedSalesOrders, afterCreateAndBuild } = useCreateAndBuildContext()

  const [onCreateWorkOrder, { error, loading }] = useCreateWorkOrderWithTasks()

  useError(error)

  const { showToast } = useToast()

  const onClick = async () => {
    //this will do create a production with items
    //it will relate also the current sales to the work order
    const workOrderInput = {
      remarks: values?.remarks,
      quantity: values?.quantity,
      relatedSalesOrders,
      tags: values?.tags,
      product: {
        _id: values?.product?._id,
      },
      items: map(values?.bomItems, (e) => {
        return {
          //get the quntity to consumed in work order items, that is the parent quantity * the child quantity
          quantity: e?.quantity * values?.quantity,
          product: {
            _id: e?.product?._id,
          },
        } as WorkOrderItem
      }),
    } as WorkOrder

    const newWorkOrder = await onCreateWorkOrder({ workOrder: workOrderInput })

    afterCreateAndBuild?.()

    showToast({
      title: 'Production Created',
      message: `Production #${newWorkOrder?.code} has been created successfully.`,
    })
  }

  return (
    <BusyButton
      onClick={onClick}
      title="Create Delayed Production"
      icon="clock"
      text="Create Delayed Production"
      variant="warning"
      isBusy={loading}
    />
  )
}
